import { AITableDefinition } from "./AITableDefinition";

export class AIDBStructure{
    constructor(){
        this.Tables = [];
    }
    Tables: Array<AITableDefinition>;
}